var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApartmentAddressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 58,
    width: 66,
    height: 7,
    fill: "#E8AE4C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 65,
    width: 66,
    height: 1,
    fill: "#EABC6B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3645,
    y: 36.6934,
    width: 15.4642,
    height: 27.6714,
    fill: "#ACA2FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 52.3564,
    y: 54.252,
    width: 9.46786,
    height: 10.1117,
    fill: "#BFE2E4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 56.8,
    y: 54.252,
    width: 0.593319,
    height: 10.1117,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.3644 7.26758V64.3524H7.63013V21.3936C7.63013 21.2421 7.63013 21.1664 7.63013 21.1664V7.26758H49.3644Z",
    fill: "#ACA2FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3645 7.26758V55.5789C32.3981 55.5789 30.3657 14.2359 30.1384 7.26758L49.3645 7.26758Z",
    fill: "#7A6DEF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.36792,
    y: 7.15234,
    width: 44.2465,
    height: 1.8052,
    fill: "#B5C5F4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.42,
    x: 7.63013,
    y: 8.95898,
    width: 41.7343,
    height: 0.896291,
    fill: "#575756"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6.36792,
    y: 26.2773,
    width: 44.2465,
    height: 1.8052,
    fill: "#B5C5F4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.42,
    x: 7.63013,
    y: 28.084,
    width: 41.7343,
    height: 0.896291,
    fill: "#575756"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 6.36792,
    y: 44.9609,
    width: 44.2465,
    height: 1.8052,
    fill: "#B5C5F4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.42,
    x: 7.63013,
    y: 46.7676,
    width: 41.7343,
    height: 0.896291,
    fill: "#575756"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 11.531,
    y: 31.668,
    width: 5.8827,
    height: 12.1567,
    fill: "#BFE2E4"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1882,
    y: 31.668,
    width: 5.87007,
    height: 12.1567,
    fill: "#BFE2E4"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8328,
    y: 31.668,
    width: 5.87007,
    height: 12.1567,
    fill: "#BFE2E4"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 40.49,
    y: 31.668,
    width: 5.87007,
    height: 12.1567,
    fill: "#BFE2E4"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 11.531,
    y: 49.4434,
    width: 5.8827,
    height: 12.1567,
    fill: "#BFE2E4"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1882,
    y: 49.4434,
    width: 5.87007,
    height: 12.1567,
    fill: "#BFE2E4"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8328,
    y: 49.4434,
    width: 5.87007,
    height: 12.1567,
    fill: "#BFE2E4"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 40.49,
    y: 49.4434,
    width: 5.87007,
    height: 12.1567,
    fill: "#BFE2E4"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 11.531,
    y: 12.5312,
    width: 5.8827,
    height: 12.1567,
    fill: "#BFE2E4"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1882,
    y: 12.5312,
    width: 5.87007,
    height: 12.1567,
    fill: "#BFE2E4"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8328,
    y: 12.5312,
    width: 5.87007,
    height: 12.1567,
    fill: "#BFE2E4"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 40.49,
    y: 12.5312,
    width: 5.87007,
    height: 12.1567,
    fill: "#BFE2E4"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 36.2358,
    y: 3.71875,
    width: 4.25422,
    height: 3.43368,
    fill: "#878787"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 11.0513,
    y: 3.71875,
    width: 6.34978,
    height: 3.43368,
    fill: "#878787"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 9.52368,
    y: 3,
    width: 9.35424,
    height: 1.08565,
    fill: "#B2B2B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3162 12.5312L21.1882 21.6835V23.3372L26.1241 12.5312H25.3162Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6716 12.5312L11.531 21.6835V23.3372L16.4795 12.5312H15.6716Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9734 12.5312L30.8328 21.6835V23.3372L35.7813 12.5312H34.9734Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3288 31.668L21.1882 40.8076V42.4613L26.1368 31.668H25.3288Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6306 31.668L40.49 40.8076V42.4613L45.4385 31.668H44.6306Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6717 31.668L11.5437 40.8076V42.4613L16.4922 31.668H15.6717Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9861 31.668L30.8455 40.8076V42.4613L35.794 31.668H34.9861Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3288 49.4434L21.1882 58.583V60.2367L26.1368 49.4434H25.3288Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1542 35.6064V37.7398H64.8287V53.1661C62.6448 53.1661 60.9785 52.2572 59.7035 50.8433C59.1354 50.2247 58.6431 49.4926 58.2265 48.7099C58.1003 48.4827 57.9866 48.2554 57.873 48.0156C57.2545 46.6901 56.8 45.2383 56.4718 43.7992C56.3077 43.0797 56.1688 42.3601 56.0552 41.6658C56.0173 41.426 55.9795 41.1987 55.9542 40.9715C55.7775 39.747 55.6891 38.6235 55.6386 37.7272C55.6134 37.3232 55.6007 36.9697 55.6007 36.6794C55.5755 35.9977 55.5881 35.5938 55.5881 35.5938H66.1542V35.6064Z",
    fill: "#7A6DEF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6717 49.4434L11.5437 58.583V60.2367L16.4922 49.4434H15.6717Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9861 49.4434L30.8455 58.583V60.2367L35.794 49.4434H34.9861Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6306 49.4434L40.49 58.583V60.2367L45.4385 49.4434H44.6306Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6306 12.5312L40.49 21.6835V23.3372L45.4385 12.5312H44.6306Z",
    fill: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 11.531,
    y: 31.668,
    width: 5.8827,
    height: 1,
    fill: "#5D5839"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1882,
    y: 31.668,
    width: 5.87007,
    height: 1,
    fill: "#5D5839"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8328,
    y: 31.668,
    width: 5.8827,
    height: 1,
    fill: "#5D5839"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 40.49,
    y: 31.668,
    width: 5.87007,
    height: 1,
    fill: "#5D5839"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 11.531,
    y: 49.4434,
    width: 5.8827,
    height: 1,
    fill: "#5D5839"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1882,
    y: 49.4434,
    width: 5.87007,
    height: 1,
    fill: "#5D5839"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8328,
    y: 49.4434,
    width: 5.8827,
    height: 1,
    fill: "#5D5839"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 40.49,
    y: 49.4434,
    width: 5.87007,
    height: 1,
    fill: "#5D5839"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 11.531,
    y: 12.5312,
    width: 5.8827,
    height: 1,
    fill: "#5D5839"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 21.1882,
    y: 12.5312,
    width: 5.87007,
    height: 1,
    fill: "#5D5839"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 30.8328,
    y: 12.5312,
    width: 5.8827,
    height: 1,
    fill: "#5D5839"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 40.49,
    y: 12.5312,
    width: 5.87007,
    height: 1,
    fill: "#5D5839"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 52.3564,
    y: 54.252,
    width: 9.46786,
    height: 0.69431,
    fill: "#48452B"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 50.4124,
    y: 40.9844,
    width: 13.4949,
    height: 2.82773,
    fill: "#BFE2E4"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 50.4124,
    y: 40.9844,
    width: 13.4949,
    height: 0.69431,
    fill: "#5D5839"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 50.4124,
    y: 48.0293,
    width: 13.4949,
    height: 2.82773,
    fill: "#BFE2E4"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 50.4124,
    y: 48.0293,
    width: 13.4949,
    height: 0.69431,
    fill: "#5D5839"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 49.3645,
    y: 35.6074,
    width: 16.7897,
    height: 2.13342,
    fill: "#B5C5F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentAddressIcon);
export default __webpack_public_path__ + "static/media/apartment-address-icon.adc61d25567334d29f660479ef3e522b.svg";
export { ForwardRef as ReactComponent };